import { render } from "./DatabasesModule.vue?vue&type=template&id=a3b2d788&scoped=true"
import script from "./DatabasesModule.vue?vue&type=script&lang=js"
export * from "./DatabasesModule.vue?vue&type=script&lang=js"

import "./DatabasesModule.vue?vue&type=style&index=0&id=a3b2d788&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a3b2d788"

export default script